import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Canvas } from '@react-three/fiber';

import { useAppStore } from './appStore'
import Layout from './Layout';
import Imprint from './Imprint'
//import RunningRabbit from './RunningRabbit'
import ConeFigures from 'lib/cones/ConeFigures'
import FoxGame from 'bundles/Cone/components/FoxGame'
import Monster from 'lib/misc/Monster'
import Video from 'lib/misc/Video'

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<ConeFigures />} />
                    <Route path="/interactive/cones" element={<ConeFigures />} />
                    <Route path="/interactive/fox-and-rabbit" element={<FoxGame />} />
                    <Route path="/interactive/monster" element={<Monster />} />
                    <Route path="/clips/monsters" element={
                        <Video
                            src={'/assets/clips/monsters.mp4'}
                            title={'Monsters'}
                            texts={[
                                'A small clip with the monsters, made with Blender.',
                                'Biggest thanks to Hans Weizenegger for the sound effects.'
                            ]}
                        />
                    } />
                    <Route path="/clips/fox-and-rabbit" element={
                        <Video
                            src={'/assets/clips/fox-and-rabbit.mp4'}
                            title={'Foxes and Rabbits'}
                            texts={[
                                'A tiny clip with foxes and rabbits, made using Blender`s flock system.',
                                'Biggest thanks to Hans Weizenegger for the sound effects.'
                            ]}
                            autoplay
                            loop
                        />
                    } />
                    <Route path="imprint" element={<Imprint />} />
                    <Route path="*" element={<NoPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}


function NoPage() {
    return (
        <div className="no-page">
            <h1>404</h1>
        </div>
    )
}


    //const viewMode = useAppStore((state) => state.view)

    //if (viewMode === 'imprint') {
        //return (layout(<Imprint />, viewMode))
    //}

    //if (viewMode === 'monster') {
        //return (
            //layout(
                //<>
                    //<iframe src="/various/monster" width="100%" height="100%" />
                    //<InfoBox
                        //title="Little Monster Game"
                        //position={[1, -2, 0]}
                    //>
                        //<ul>
                            //<li>Monster modeled, textured, rigged and animated with Blender.</li>
                            //<li>Gamelogic made with Three.js.</li>
                            //<li>Included as IFrame here (I made it years ago with an old version of Three.js).</li>
                            //<li>Floor-image taken from free img-library: http://seamless-pixels.blogspot.de/2012/09/free-seamless-ground-textures.html.</li>
                            //<li>Background: 360° panorama taken from http://photoflap.wordpress.com/2012/06/06/the-singing-sand-dune/.</li>
                            //<li>Laughing from http://freesound.org/people/sandyrb/ </li>
                            //<li>Roaring from http://static1.grsites.com/archive/sounds/animals/animals032.wav </li>
                        //</ul>
                    //</InfoBox>
                //</>,
                //viewMode
            //)
        //)
    //}

    //if (viewMode === 'cones') {
        //return (layout(<ConeFigures />, viewMode))
    //}

    //if (viewMode === 'foxAndRabbit') {
        //return (layout(<FoxGame />, viewMode))
    //}

//}

